(function () {
  'use strict';

  function SportInterceptorFactory($rootScope) {
    var isNotHtml = function (config) {
      return config.url.indexOf('html') === -1;
    };

    var isNotJson = function (config) {
      return config.url.indexOf('json') === -1;
    };

    var isApiRequest = function (config) {
      return config.url.indexOf('api') > -1;
    };

    return {
      request: function (config) {
        const sportId = $rootScope.sportId;

        if (isNotHtml(config) && isNotJson(config) && isApiRequest(config)) {
          config.headers['x-sportcontract-sportid'] = sportId;
        }

        return config;
      },
    };
  }

  var commonModule = angular.module('app.common');
  commonModule.factory('SportInterceptorFactory', SportInterceptorFactory);
})();
